import { useEffect, useRef } from 'react'
import {
  Image, Film, Type, Square, Copy, Trash2
} from 'lucide-react'

export default function ContextMenu({
  type,
  x, y,
  nodeId,
  nodeType,
  onClose,
  onAddNode,
  onDuplicate,
  onDelete,
}) {
  const menuRef = useRef(null)

  useEffect(() => {
    const handleClick = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) onClose()
    }
    const handleKey = (e) => { if (e.key === 'Escape') onClose() }
    document.addEventListener('mousedown', handleClick)
    document.addEventListener('keydown', handleKey)
    return () => {
      document.removeEventListener('mousedown', handleClick)
      document.removeEventListener('keydown', handleKey)
    }
  }, [onClose])

  const menuWidth = 200
  const left = Math.min(x, window.innerWidth - menuWidth - 16)
  const top = Math.min(y, window.innerHeight - 300)

  const Item = ({ icon: Icon, label, onClick, danger, divider }) => (
    <>
      {divider && <div className="border-t border-surface-border my-1" />}
      <button
        onClick={() => { onClick(); onClose() }}
        className={`w-full flex items-center gap-2.5 px-3 py-2 text-sm rounded-lg transition-colors text-left ${
          danger
            ? 'text-red-400 hover:bg-red-500/10'
            : 'text-slate-200 hover:bg-surface-hover'
        }`}
      >
        <Icon size={14} className={danger ? 'text-red-400' : 'text-slate-400'} />
        {label}
      </button>
    </>
  )

  return (
    <div
      ref={menuRef}
      className="fixed z-50 bg-surface-card border border-surface-border rounded-xl shadow-2xl py-1.5 px-1.5"
      style={{ left, top, minWidth: menuWidth }}
    >
      {type === 'pane' ? (
        <>
          <div className="px-3 py-1.5 text-xs text-slate-500 font-medium uppercase tracking-wider">Add to Canvas</div>
          <Item icon={Image}  label="Image Generator" onClick={() => onAddNode('imageGenerator', { x, y })} />
          <Item icon={Film}   label="Video Generator" onClick={() => onAddNode('videoGenerator',  { x, y })} />
          <Item icon={Type}   label="Annotation Note" onClick={() => onAddNode('annotation',      { x, y })} />
          <Item icon={Square} label="Group / Section" onClick={() => onAddNode('group',           { x, y })} />
        </>
      ) : (
        <>
          <div className="px-3 py-1.5 text-xs text-slate-500 font-medium uppercase tracking-wider">
            {nodeType === 'imageGenerator' ? 'Image Node' :
             nodeType === 'videoGenerator' ? 'Video Node' :
             nodeType === 'annotation'     ? 'Note'       : 'Group'}
          </div>
          <Item icon={Copy}   label="Duplicate"  onClick={() => onDuplicate(nodeId)} />
          <Item icon={Trash2} label="Delete"     onClick={() => onDelete(nodeId)}    danger divider />
        </>
      )}
    </div>
  )
}
